import { CompositeScreenProps } from '@react-navigation/native'
import React, { useState } from 'react'
import { ScrollView } from 'react-native'

import { NavMenuButton } from 'partials/MobileNav/types'
import { Page } from 'partials/Page'
import { RecentWorkouts } from 'partials/RecentWorkouts'
import { TrendingWorkouts } from 'partials/TrendingWorkouts/TrendingWorkouts'
import { WorkoutTagsModal } from 'partials/WorkoutTags'
import { WorkoutTagsFilter } from 'partials/WorkoutTagsFilter'

import { Box } from 'widgets/Box'
import { Separator } from 'widgets/Separator'

import { useDiscoverContent } from 'hooks/useDiscoverContent'
import { useInfinitePosts } from 'hooks/useInfinitePosts'
import { useTrendingWorkouts } from 'hooks/useTrendingWorkouts'

import { useFocusMode } from 'contexts/FocusModeContext'

export const WorkoutsPage = ({ navigation }: CompositeScreenProps<any, any>) => {
  const [isTagsModalVisible, setIsTagsModalVisible] = useState<boolean>(false)
  const [tagFilter, setTagFilter] = useState<any>(undefined)

  const handleFilterPress = () => {
    setIsTagsModalVisible(true)
  }

  const filterButton: NavMenuButton = {
    iconName: 'filter',
    onPress: handleFilterPress,
  }

  const { data: discoverContent, isLoading: isLoadingDiscoverContent } = useDiscoverContent()
  const { data: trendingWorkouts, isLoading: isLoadingTrendingWorkouts } = useTrendingWorkouts()

  const focusMode = useFocusMode()
  const { data: recentWorkouts, isLoading: isLoadingRecentWorkouts } = useInfinitePosts({
    creatorId: focusMode.group ? focusMode.group?.trainer.id : undefined,
    limit: focusMode.group ? undefined : 25,
    order: 'created',
    filter: 'Workouts',
  })

  return (
    <Page
      backgroundColor='white'
      title='Workouts'
      withNav
      withBack
      navigation={navigation}
      navbarRightButtons={[filterButton]}
      isLoading={isLoadingDiscoverContent || isLoadingTrendingWorkouts}
    >
      <Separator />
      <Box flex={1}>
        {tagFilter ? (
          <WorkoutTagsFilter filters={tagFilter} handleEditFilter={handleFilterPress} />
        ) : (
          <Box flex={1} padding='sm'>
            <ScrollView>
              <RecentWorkouts
                title='Recent'
                recentWorkouts={recentWorkouts}
                isLoadingRecentWorkouts={isLoadingRecentWorkouts}
                focusModeProgram={focusMode?.group}
              />
              <TrendingWorkouts
                discoverContent={discoverContent}
                isLoadingDiscoverContent={isLoadingDiscoverContent}
                trendingWorkouts={trendingWorkouts}
                isLoadingTrendingWorkouts={isLoadingTrendingWorkouts}
              />
            </ScrollView>
          </Box>
        )}
      </Box>
      <WorkoutTagsModal
        isFilter
        isVisible={isTagsModalVisible}
        onClose={(selection: any) => {
          setIsTagsModalVisible(false)
          setTagFilter(selection)
        }}
      />
    </Page>
  )
}
